// import { Platform } from '@angular/cdk/platform'; // Unused import
import { Inject, Injectable, LOCALE_ID } from '@angular/core';
import { MatDateFormats, MAT_DATE_LOCALE, NativeDateAdapter } from '@angular/material/core';
import { dateFormat, mediumDateFormat } from '@core/config';
import { DatePipe } from '@shared/pipes/date/date.pipe';
import { parse } from 'date-fns';

@Injectable()
export class WaiDateAdapter extends NativeDateAdapter {
  constructor(
    @Inject(LOCALE_ID) private localeId: string,
    @Inject(MAT_DATE_LOCALE) matDateLocale: string,
    // platform: Platform, // Unused import
  ) {
    super(matDateLocale);
  }

  // disable linter rule to match parent class function signature
  public format(date: Date, displayFormat: Object): string {
    if (displayFormat === 'input') {
      return new DatePipe(this.localeId).transform(date);
    }

    return new DatePipe(this.localeId).transform(date, mediumDateFormat);
  }

  public parse(value: unknown): Date | null {
    if (!value) {
      return null;
    }

    const parsedDate = parse(`${value}`, dateFormat, new Date());
    // Create local date instead of UTC to prevent timezone shifting
    return new Date(parsedDate.getFullYear(), parsedDate.getMonth(), parsedDate.getDate());
  }
}

export const WAI_DATE_FORMATS: MatDateFormats = {
  parse: {
    dateInput: { month: 'short', year: 'numeric', day: 'numeric' },
  },
  display: {
    dateInput: 'input',
    monthYearA11yLabel: { year: 'numeric', month: 'long' },
    monthYearLabel: { year: 'numeric', month: 'numeric' },
    dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
  },
};
